module.exports = __webpack_public_path__ + "img/icon-delete.6ca1cfbb.svg";